export class AtlStepperClickEvent extends CustomEvent<{ payload: string }> {
   static EVENT_NAME = 'step-click';

   constructor(detail: { payload: string }) {
      super(AtlStepperClickEvent.EVENT_NAME, {
         detail,
         bubbles: true,
         composed: true,
      });
   }
}
